import { BaseBadge } from './BaseBadge';
import { BaseToolBadgeProps } from './types';

export const ReadDocumentBadge = ({ isDone, ...props }: BaseToolBadgeProps) => {
  const allProps = { ...props, isDone };

  return (
    <BaseBadge
      {...allProps}
      showArgs={false}
      resultTexts={{
        loading: 'Reading document...',
        done: `Read document  `,
        error: 'Error reading document',
      }}
    />
  );
};
